export default __webpack_public_path__ + "static/media/radio-button-selected.0f6f4bc5.svg";